export default class PosterImagePositionFull {
    constructor(frame, posterImage, dimensions) {
        this.x = dimensions.framePadding + (frame.paperOuterPadding / 2);
        this.y = dimensions.framePadding + (frame.paperOuterPadding / 2);
        this.width = posterImage.width - dimensions.framePadding - frame.paperOuterPadding;
        this.height = posterImage.height - dimensions.framePadding - frame.paperOuterPadding;
    }
}
